import { getCountries } from '@/services/country'

const quoteServicesModel = vm => ({
  title: vm.$gettext('Service Quotes'),
  endpoint: 'quote-services',
  allowNew: true,
  allowDelete: true,
  // allowBulk: true,
  countrizeById: 'country_id',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'service_id',
      label: vm.$gettext('Service'),
      required: true,
      sortable: true,
      editable: true,
      formatter: (value, key, item) => {
        return item.service.description || item.service.name
      }
    },
    {
      key: 'country_id',
      label: vm.$gettext('Country'),
      sortable: true,
      editable: true,
      formatter: (value, key, item) => {
        return getCountries().find(x => x.id === value).iso_code
      }
    },
    {
      key: 'company_id',
      label: vm.$gettext('Company'),
      formatter: (value, key, item) => {
        return item.company ? item.company.name : ''
      }
    },
    {
      key: 'currency',
      label: vm.$gettext('Currency')
    },
    {
      key: 'price_formula',
      label: vm.$gettext('Price Formula')
    },
    {
      key: 'courier_commission_formula',
      label: vm.$gettext('Courier Commission Formula')
    },
    {
      key: 'min_price',
      label: vm.$gettext('Min. Price')
    },
    {
      key: 'max_price',
      label: vm.$gettext('Max. Price')
    }
  ],
  filters: ['id', 'name', 'service.description', 'company.name', 'country.iso_code'],
  includes: ['service', 'company', 'country']
})

export default quoteServicesModel
